/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Clients_Tags_Delete_ConfirmInputs */

const cs_clients_tags_delete_confirm = /** @type {(inputs: Clients_Tags_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Smazat štítek „${i?.name}“? Odebere se ze všech klientů.`)
};

const en_clients_tags_delete_confirm = /** @type {(inputs: Clients_Tags_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete tag “${i?.name}”? It will be removed from all clients.`)
};

/**
* | output |
* | --- |
* | "Delete tag “{name}”? It will be removed from all clients." |
*
* @param {Clients_Tags_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_delete_confirm = /** @type {((inputs: Clients_Tags_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_delete_confirm(inputs)
	return cs_clients_tags_delete_confirm(inputs)
});